var _a;
import { IdScene } from "../../features/scenes/types/IdScene";
import { IdEventSoundCore } from "../../utils/sound/IdEventSoundCore";
import { soundSpriteConfig } from "./soundSpriteConfig";
export var soundEventConfig = (_a = {},
    _a[IdEventSoundCore.None] = {},
    _a[IdEventSoundCore.Music] = {
        loop: true,
        playWithParams: function (sceneId) {
            if (sceneId === IdScene.PlayerBase) {
                return [soundSpriteConfig.MU_Main_01];
            }
            return [];
        },
    },
    // Base buildings
    _a[IdEventSoundCore.BuildingCelebration] = {
        play: [soundSpriteConfig.UI_BuildingCelebration],
    },
    _a[IdEventSoundCore.BuildingFinish] = {
        play: [soundSpriteConfig.UI_BuildingFinish],
    },
    _a[IdEventSoundCore.BuildingStartMove] = {
        play: [soundSpriteConfig.UI_BuildingPick],
    },
    _a[IdEventSoundCore.BuildingFinishMove] = {
        play: [soundSpriteConfig.UI_BuildingPlace],
    },
    _a[IdEventSoundCore.BuildingRotate] = {
        play: [soundSpriteConfig.UI_BuildingRotate],
    },
    _a[IdEventSoundCore.BuildingProductionFinish] = {
        play: [soundSpriteConfig.UI_HarvestReady],
    },
    // Production
    _a[IdEventSoundCore.ProduceFeed] = {
        play: [soundSpriteConfig.UI_ProduceFeed],
    },
    _a[IdEventSoundCore.ProduceFertilizer] = {
        play: [soundSpriteConfig.UI_ProduceFertilise],
    },
    _a[IdEventSoundCore.ProduceProduct] = {
        play: [soundSpriteConfig.UI_ProduceProduct],
    },
    _a[IdEventSoundCore.ProduceSow] = {
        play: [soundSpriteConfig.UI_ProduceSow],
    },
    // Outskirts
    _a[IdEventSoundCore.WatertowerCollect] = {
        play: [soundSpriteConfig.UI_Collectwater],
    },
    _a[IdEventSoundCore.MarketContractTrash] = {
        play: [soundSpriteConfig.UI_ContractTrash],
    },
    _a[IdEventSoundCore.MarketContractStart] = {
        play: [soundSpriteConfig.SFX_Truck_Start, soundSpriteConfig.SFX_Truck_Loop],
        playInSequence: true,
    },
    _a[IdEventSoundCore.MarketContractLoop] = {
        play: [soundSpriteConfig.SFX_Truck_Loop],
        stop: [soundSpriteConfig.SFX_Truck_Start],
    },
    _a[IdEventSoundCore.MarketContractFinish] = {
        play: [soundSpriteConfig.SFX_Truck_Stop],
        stop: [soundSpriteConfig.SFX_Truck_Loop],
    },
    // Dog
    _a[IdEventSoundCore.DogIdlePlayful] = {
        play: [soundSpriteConfig.Dog_IdlePlayful],
    },
    _a[IdEventSoundCore.DogSniff] = {
        play: [soundSpriteConfig.Dog_Sniff],
    },
    // Generic
    _a[IdEventSoundCore.ButtonClick] = {
        play: [soundSpriteConfig.UI_Generic],
    },
    _a[IdEventSoundCore.ButtonPagerClick] = {
        play: [soundSpriteConfig.UI_Scroll],
    },
    _a[IdEventSoundCore.LevelUp] = {
        play: [soundSpriteConfig.UI_LevelUp],
    },
    _a[IdEventSoundCore.QuestComplete] = {
        play: [soundSpriteConfig.UI_QuestComplete],
    },
    _a[IdEventSoundCore.SpendGold] = {
        play: [soundSpriteConfig.UI_SpendGold],
    },
    // Items
    _a[IdEventSoundCore.ItemCollect] = {
        delayInBetween: 1000,
        play: [soundSpriteConfig.UI_ItemSpawn, soundSpriteConfig.UI_ItemCollect],
        playInSequence: true,
    },
    _a[IdEventSoundCore.ItemSell] = {
        play: [soundSpriteConfig.UI_ItemSold],
    },
    _a[IdEventSoundCore.ItemSpawn] = {
        play: [soundSpriteConfig.UI_ItemSpawn],
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/setup/sound/soundEventConfig.ts
// module id = 2516
// module chunks = 3